import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import DetailContent from './content';
import SaveButton from './buttons/save';
import SendButton from './buttons/send';
import ProcessButton from './buttons/process';
import DeleteButton from './buttons/delete';
import ClaimModal from './claim';
import './detail.scss';

class ReturnOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  componentDidMount() {
    const {returnOrder} = this.props;

    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PartsReturns,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }

    if (returnOrder) {
      this.props.getPartsReturnDetail(returnOrder.code);
    }
  }

  componentDidUpdate(prevProps) {
    const {returnOrder} = this.props;
    if (returnOrder && returnOrder !== prevProps.returnOrder) {
      this.props.getPartsReturnDetail(returnOrder.code);
    }
  }

  onCancelClick() {
    this.props.navigateTo(paths.PartsReturns);
  }

  getReturnNumber() {
    const {returnOrder} = this.props;
    return returnOrder ? returnOrder.orderNumber : null;
  }

  render() {
    return (
      <div className='parts-returns-detail'>
        <Card raised fluid className='title-section'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='10' textAlign='left'>
                <h2>
                  <Icon name='arrow left' onClick={this.onCancelClick} />
                  Orden de Devolución {this.getReturnNumber()}
                </h2>
              </Grid.Column>
              <Grid.Column width='6' textAlign='right'>
                <ClaimModal />
                <DeleteButton />
                <SaveButton />
                <SendButton />
                <ProcessButton />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <DetailContent />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  getPartsReturnDetail,
} = Actions;

export default connect(mapStateToProps, {navigateTo, getPartsReturnDetail})(ReturnOrderDetail);
